jQueryCS(document).ready(function($) {
  $(".dropdown-currency i").click(function(){
    $(".dropdown-inner").toggleClass("active");
    $(".dropdown-inner").slideToggle();
  });
});

jQueryCS(document).ready(function(){
    jQueryCS('.template-customers-login div#CustomerLoginForm').append('<p class="account-register-area"><a href="/account/register">Or not have account? Register here</a>');
    jQueryCS('#CustomerRegisterForm a#customer_login_link').attr('href' , '/account/login' )
});




  jQueryCS(document).ready(function() { 
    jQueryCS('.cs-swatch').click(function() {
        var matchd = jQueryCS(this).data('value'); 
 
        jQueryCS('.pro-slider-with-thumb[data-coloroption="' + matchd + '"]').css({'opacity': '1', 'visibility': 'visible'});
        jQueryCS('.pro-slider-with-thumb[data-coloroption="' + matchd + '"]').siblings('.pro-slider-with-thumb').css({'opacity': '0', 'visibility': 'hidden'});
        jQueryCS('.pro-slider-with-thumb[data-coloroption="' + matchd + '"]').addClass('pro-slider_active');
        jQueryCS('.pro-slider-with-thumb[data-coloroption="' + matchd + '"]').siblings('.pro-slider-with-thumb').removeClass('pro-slider_notactive');
    });
});




  jQueryCS(document).ready(function() {
  jQueryCS('.view-size-chart').click(function() {
    jQueryCS('.size_chartpop').addClass('active-sizepop');
  });
    jQueryCS('.cloase-btn').click(function() {
    jQueryCS('.size_chartpop').removeClass('active-sizepop');
  });
});

//   $(document).ready(function() {
//   $('.view-size-chart').click(function() {
//     $('.size_chartpop').addClass('active-sizepop');
//   });
//     $('.cloase-btn').click(function() {
//     $('.size_chartpop').removeClass('active-sizepop');
//   });
// });